import React, { useState } from "react";
import { Row, Col, Button, Form, Input, Steps, Upload } from "antd";
import { ArrowLeftOutlined, UploadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Application3.css";
import "../components/StepsTracker.css";

const { Dragger } = Upload;

const Application3: React.FC = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const handleUploadChange = (info: any) => {
    setFileList(info.fileList);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    fileList,
    onChange: handleUploadChange,
    beforeUpload: () => false, // Prevent auto upload
    accept: ".jpeg,.jpg,.png,.HEIC,.pdf",
  };

  return (
    <div className="application-step-container">
      {/* Header Component would be rendered by Layout in App.tsx */}

      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={2}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">3</div>
          </div>
          <h2 className="step-title-main">
            Your contact & residency information
          </h2>
        </div>

        <div className="step-divider" />

        <div className="form-section">
          <Form form={form} layout="vertical" className="contact-form">
            <div className="contact-info-section">
              <h3 className="section-title">Contact Information</h3>

              <Row gutter={24}>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    className="form-item"
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    className="form-item"
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24} lg={12}>
                  <Form.Item name="phone" label="Phone" className="form-item">
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item name="email" label="Email" className="form-item">
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="address-info-section">
              <h3 className="section-title">Address & Residency</h3>

              <Row gutter={24}>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name="streetAddress"
                    label="Street Address"
                    className="form-item"
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name="suite"
                    label="Suite, apartment, etc."
                    className="form-item"
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col xs={24} sm={8}>
                  <Form.Item name="city" label="City" className="form-item">
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item name="state" label="State" className="form-item">
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item name="zip" label="Zip" className="form-item">
                    <Input className="form-input" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="upload-section">
              <h3 className="section-title">Upload Residency Verification</h3>
              <p className="upload-description">
                Attach one of these documents as{" "}
                <span className="underlined-link">Residency Verification</span>.
              </p>

              <Dragger {...uploadProps} className="upload-dragger">
                <div className="upload-content">
                  <img
                    src="/images/logo.svg"
                    alt="Upload icon"
                    className="upload-icon"
                  />
                  <p className="upload-text">
                    Click here or drag file to this area to upload.
                  </p>
                  <p className="upload-hint">
                    Acceptable file formats include .jpeg, .png, .HEIC or .pdf
                  </p>
                </div>
              </Dragger>
            </div>
          </Form>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application2">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Link to="/application4">
          <Button type="primary" className="next-button" size="large">
            Next
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Application3;
